// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3uzFa","inputWrap":"styles_inputWrap__31rUx","input":"styles_input__2d8or"};